// google maps
// only for multiple-marker map usage
var mapsLoader = null;
var latlong = false;
var address = '';
var scriptLocation = '';
var markerIcon = 'marker';
if ($("#google-maps-multiple-markers").length > 0 && typeof google_maps_markers !== 'undefined') {
    $(function () {
        scriptLocation = $("#google-maps-multiple-markers").data('script');

        tryToInitializeGmaps();
        $(window).on('resize scroll', function () {
            tryToInitializeGmaps();
        });

        $('#unit-mi, #unit-km').on('change', function () {
            getDistancesByUnit($(this).val());
        });

    });

    function tryToInitializeGmaps() {
        if ($('#google_maps_wrapper').isInViewport()) {
            if (mapsLoader === null) {
                lazyLoadGoogleMap();
            }
        }
    }

    function initializeGmaps() {
        //marker clusterer
        let mc;
        let mcOptions = {gridSize: 40, maxZoom: 9};

        let markers = [];
        let infowindow = new google.maps.InfoWindow();
        let bounds = new google.maps.LatLngBounds();
        let maxZoom = 9;
        let cityCircle = false;

        let mapsOptions = {
            zoom: 10,
            center: new google.maps.LatLng(google_maps_center['lat'], google_maps_center['lng']),
            scrollwheel: false,
            disableDefaultUI: true,
            panControl: false,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL,
                position: google.maps.ControlPosition.TOP_LEFT
            },

            mapTypeControl: false,
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{
                stylers		: [{saturation:-100}]
            },{
                featureType	: "administrative",
                elementType	: "labels",
                stylers		: [{visibility:"on"}]
            },{
                featureType	: "poi",
                elementType	: "labels",
                stylers		: [{ visibility: "off" }]
            },{
                featureType	: "water",
                elementType	: "labels",
                stylers		: [{ visibility: "off" }]
            },{
                featureType	: "road",
                elementType	: "labels",
                stylers		: [{ visibility: "off" }]
            },{
                featureType	: 'water',
                stylers		: [{ color: '#999999' }]
            }]
        };


        let map = new google.maps.Map(
            document.getElementById("google-maps-multiple-markers"),
            mapsOptions
        );

        /*map.addListener("center_changed", () => {
            var lat0 = map.getBounds().getNorthEast().lat();
            var lng0 = map.getBounds().getNorthEast().lng();
            var lat1 = map.getBounds().getSouthWest().lat();
            var lng1 = map.getBounds().getSouthWest().lng();
            console.log(lat0, lng0, lat1, lng1);
            console.log(map.getCenter().lat(), map.getCenter().lng());
        });*/

        MarkerClusterer.IMAGE_PATH = "./frontend/images/markerclusterer/images/m";
        mc = new MarkerClusterer(map, [], mcOptions);

        if (typeof google_maps_company_marker !== 'undefined' && google_maps_company_marker !== false) {
            let marker = new google.maps.Marker({
                icon: 'frontend/images/marker-office.png',
                position: new google.maps.LatLng(google_maps_company_marker['lat'], google_maps_company_marker['lng']),
                map: map
            });


            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    infowindow.setContent('<strong>' + google_maps_company_marker['description'] + '</strong><br>' + google_maps_company_marker['address']);
                    infowindow.open(map, marker);

                }
            })(marker));

        }


        if (typeof google_maps_markers !== 'undefined' && google_maps_markers.length > 0) {

            for (let i = 0; i < google_maps_markers.length; i++) {
                var markerIcon = 'marker';
                if (typeof google_maps_markers[i]['type'] !== 'undefined' && google_maps_markers[i]['type'] !== '') {
                    markerIcon = google_maps_markers[i]['type'];
                }
                markers[i] = new google.maps.Marker({
                    icon: 'frontend/images/'+ markerIcon +'.png',
                    position: new google.maps.LatLng(google_maps_markers[i]['latLng']['lat'], google_maps_markers[i]['latLng']['lng']),
                    map: map
                });

                if (typeof searchMarker !== 'undefined' && searchMarker !== false) {
                } else {
                    bounds.extend(markers[i].position);
                }

                google.maps.event.addListener(markers[i], 'click', (function (marker, i) {
                    return function () {
                        infowindow.setContent(google_maps_markers[i].address);
                        infowindow.open(map, marker);

                        toggleFranchise(google_maps_markers[i].franchise.id);

                    }
                })(markers[i], i));

                mc.addMarker(markers[i]);

            }

        }

        let listener = google.maps.event.addListener(map, "idle", function () {
            map.setZoom(3);
            google.maps.event.removeListener(listener);
        });


        if (typeof searchMarker !== 'undefined' && searchMarker !== false) {
            let myLatLng = new google.maps.LatLng(searchMarker['lat'], searchMarker['lng']);
            let marker = new google.maps.Marker({
                icon: 'frontend/images/search-marker.png',
                position: myLatLng,
                map: map
            });

            bounds.extend(marker.position);
            map.setCenter(myLatLng);

            // Add circle overlay and bind to marker
            var circle = new google.maps.Circle({
                map: map,
                radius: maxDistance*1000,
                fillColor: '#283135',
                fillOpacity: 0.1,
                strokeColor: '#283135',
                strokeOpacity: 0.5,
                strokeWeight: 1
            });
            circle.bindTo('center', marker, 'position');

        } else {

            let userPos = false;

            // Try HTML5 user geolocation.
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {

                    userPos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    // save local storage
                    window.localStorage.setItem('userPos', JSON.stringify(userPos));

                    // set user marker
                    new google.maps.Marker({
                        icon: 'frontend/images/search-marker.png',
                        position: userPos,
                        map: map
                    });

                    // set map
                    map.setCenter(userPos);
                    map.setZoom(9);

                }, function() {
                });
            }

            if (userPos === false) {

                // check local storage
                if (localStorage.getItem('userPos') !== null) {
                    userPos = JSON.parse(window.localStorage.getItem('userPos'));

                    // set user marker
                    new google.maps.Marker({
                        icon: 'frontend/images/search-marker.png',
                        position: userPos,
                        map: map
                    });

                    // set map
                    map.setCenter(userPos);
                    map.setZoom(9);

                } else {

                    // fit bounds to site
                    let bounds = new google.maps.LatLngBounds(new google.maps.LatLng(google_maps_bounds.southwest.lat, google_maps_bounds.southwest.lng), new google.maps.LatLng(google_maps_bounds.northeast.lat, google_maps_bounds.northeast.lng));
                    map.fitBounds(bounds);
                }

            }

        }


        // franchise click
        $('.show-franchise-info').on('click', function (e) {
            e.preventDefault();

            let franchiseId = $(this).data('franchiseId');

            // find map marker in markers array with the same title
            for (let i = 0; i < google_maps_markers.length; i++) {
                if (google_maps_markers[i].franchise.id === franchiseId.toString()) {

                    // and click it using google events API
                    new google.maps.event.trigger(markers[i], 'click');

                    break;
                }
            }

        });

    }

    function lazyLoadGoogleMap() {
        mapsLoader = $.getScript(scriptLocation)
            .done(function () {
                initializeGmaps();
            })
            .fail(function (jqxhr, settings, ex) {
                alert("Could not load Google Map script");
            });
    }

    function toggleFranchise(franchiseId) {

        // hide all
        $('.franchise-info').hide();
        $('.franchise-block').removeClass('active');

        // show
        $('.franchise-info[data-franchise-id="' + franchiseId + '"]').show();
        $('.franchise-info[data-franchise-id="' + franchiseId + '"]').closest('.franchise-block').addClass('active');

    }

    function getDistancesByUnit(unit) {
        $.ajax({
            url		: 'ajax/distances',
            type	: 'GET',
            data    : {unitChosen: unit},
            success: function(response){
                $('#radius').remove();
                $('#label-radius').after(response);
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(thrownError);
            }
        });
    }

}
